import { Link } from "react-router-dom";
import { brand } from "../lib/brand";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <span>© {new Date().getFullYear()} {brand.name} · นโยบายและเงื่อนไขที่นี่</span>
        <nav>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <a href={brand.site.url} target="_blank" rel="noreferrer">{brand.site.label} ↗</a>
        </nav>
      </div>
    </footer>
  );
}
